const KEY = "bni-alert-history";
const MAX = 40;

export function pushAlert(entry) {
  try {
    const list = getAlerts();
    const dedupeKey = `${entry.type}:${entry.count ?? entry.title ?? ""}`;
    // avoid stamping the same alert repeatedly within 60s
    const last = list[0];
    const lastKey = last ? `${last.type}:${last.count ?? last.title ?? ""}` : null;
    if (lastKey === dedupeKey && last && Date.now() - last.ts < 60_000) return;
    const row = { id: `A-${Date.now()}`, ts: Date.now(), ...entry };
    const next = [row, ...list].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
    // announce
    window.dispatchEvent(new CustomEvent("bni-alert-push", { detail: row }));
  } catch {}
}

export function getAlerts() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function clearAlerts() {
  localStorage.setItem(KEY, "[]");
  window.dispatchEvent(new CustomEvent("bni-alert-push", { detail: null }));
}
